import { Form, Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { useState } from "react";
import getConfig from "next/config";

import AddToCart from "@containers/Catalog/Actions/AddToCart";
import InputText from "@components/Form/InputText";
import Textarea from "@components/Form/Textarea";
import {
  composeFormValidators,
  isRequired,
  hasMinLength,
  hasMaxLength,
  // isNumber,
  isInteger,
  isInRange,
  isEmail,
} from "@lib/validations";

const {
  publicRuntimeConfig: {
    settings: { websiteName, giftCard },
  },
} = getConfig();

// If changing these values, make sure to change values in card-cadou page as well
// "Cardurile cadou pot avea valoarea.."
const DEFAULT_VALUES = [200, 300, 500, 1000];
const MIN_VALUE = 200;
const MAX_VALUE = 5000;

const GiftCardForm = ({ user }) => {
  const { customer } = user;

  const [customValue, setCustomValue] = useState(false);

  const [senderName, setSenderName] = useState("");
  const [senderMessage, setSenderMessage] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [receiverEmail, setReceiverEmail] = useState("");
  const [giftCardValue, setGiftCardValue] = useState(DEFAULT_VALUES[2]);

  return (
    <Form
      onSubmit={() => {}} // Do not remove, otherwise will crash
      initialValues={{
        sender_name: `${customer?.first_name || ""} ${
          customer?.last_name || ""
        }`,
      }}
      validate={(values) => {
        const errors = {};

        if (
          values.receiver_email &&
          values.receiver_email_confirmation &&
          values.receiver_email !== values.receiver_email_confirmation
        ) {
          errors.receiver_email_confirmation = "Adresele de email nu corespund";
        }

        return errors;
      }}
      render={({ handleSubmit, submitting, pristine, invalid }) => (
        <form className="w-full" onSubmit={handleSubmit}>
          <div className="flex flex-col md:flex-row items-stretch justify-center w-full space-y-4 md:space-y-0 md:space-x-10 px-2 md:px-0 mt-12">
            <div className="flex flex-col items-start justify-start w-full h-full space-y-4">
              <h3 className="w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal">
                Detalii expeditor
              </h3>

              <div className="w-full">
                <Field
                  className="!w-full !max-w-full"
                  name="sender_name"
                  label="Numele expeditor"
                  type="text"
                  component={InputText}
                  required
                  validate={composeFormValidators(
                    isRequired(),
                    hasMinLength(3),
                    hasMaxLength(60)
                  )}
                />

                <OnChange name="sender_name">
                  {(value) => setSenderName(value)}
                </OnChange>
              </div>

              <div className="w-full">
                <Field
                  className="!w-full !max-w-full h-32"
                  name="sender_message"
                  label="Mesaj pentru destinatar"
                  type="textarea"
                  component={Textarea}
                  required
                  validate={composeFormValidators(
                    isRequired(),
                    hasMinLength(3),
                    hasMaxLength(250)
                  )}
                />

                <OnChange name="sender_message">
                  {(value) => setSenderMessage(value)}
                </OnChange>

                <span className="text-sm w-full">
                  *Cardul va fi emis pe e-mail in maximum 24 de ore de la plata
                  comenzii.
                </span>
              </div>
            </div>

            <div className="flex flex-col items-center justify-start w-full h-full space-y-4">
              <h3 className="w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal">
                Detalii destinatar
              </h3>

              <div className="w-full">
                <Field
                  className="!w-full !max-w-full"
                  name="receiver_name"
                  label="Nume destinatar"
                  type="text"
                  component={InputText}
                  required
                  validate={composeFormValidators(
                    isRequired(),
                    hasMinLength(3),
                    hasMaxLength(60)
                  )}
                />

                <OnChange name="receiver_name">
                  {(value) => setReceiverName(value)}
                </OnChange>
              </div>

              <div className="w-full">
                <Field
                  className="!w-full !max-w-full"
                  name="receiver_email"
                  label="E-mail destinatar"
                  type="email"
                  component={InputText}
                  required
                  validate={composeFormValidators(
                    isRequired(),
                    isEmail(),
                    hasMaxLength(80)
                  )}
                />

                <OnChange name="receiver_email">
                  {(value) => setReceiverEmail(value)}
                </OnChange>
              </div>

              <div className="w-full">
                <Field
                  className="!w-full !max-w-full"
                  name="receiver_email_confirmation"
                  label="Confirmare e-mail destinatar"
                  type="email"
                  component={InputText}
                  required
                  validate={composeFormValidators(
                    isRequired(),
                    isEmail(),
                    hasMaxLength(80)
                  )}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-6 items-center justify-center px-2 py-5 md:py-10 md:px-16 w-full bg-[#F7F9FF] rounded-tr-xl rounded-bl-xl mt-12">
            <h3 className="w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal text-center">
              Alege valoarea cardului cadou
            </h3>

            <ul className="flex flex-col md:flex-row items-center space-y-2 md:space-x-2 md:space-y-0 justify-center w-full">
              {DEFAULT_VALUES.map((value) => (
                <li key={value} className="w-full md:w-32">
                  <button
                    className={`flex items-center justify-center w-full p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none cursor-pointer border-primary border-2 ${
                      giftCardValue === value && !customValue
                        ? `bg-primary ${
                            websiteName === "altex"
                              ? "text-black"
                              : "text-white"
                          }`
                        : ""
                    }`}
                    onClick={() => {
                      setGiftCardValue(value);
                      setCustomValue((previous) => previous && false);
                    }}
                  >
                    {value} lei
                  </button>
                </li>
              ))}

              <li key="custom" className="w-full md:w-32">
                <button
                  className={`flex items-center justify-center w-full p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none cursor-pointer border-primary border-2 ${
                    customValue
                      ? `bg-primary ${
                          websiteName === "altex" ? "text-black" : "text-white"
                        }`
                      : ""
                  }`}
                  onClick={() => setCustomValue(true)}
                >
                  Alta suma
                </button>
              </li>
            </ul>

            {customValue && (
              <div className="w-full max-w-[810px]">
                <Field
                  className="!w-full !max-w-full"
                  name="custom_value"
                  type="text"
                  component={InputText}
                  validate={composeFormValidators(
                    isRequired(),
                    // isNumber(),
                    isInteger(),
                    isInRange(MIN_VALUE, MAX_VALUE)
                  )}
                />

                <OnChange name="custom_value">
                  {(value) => {
                    const parsed = parseInt(value.replace(/\D/g, ""));
                    if (!isNaN(parsed)) setGiftCardValue(parsed);
                  }}
                </OnChange>
              </div>
            )}
          </div>

          <div className="flex items-center justify-center w-full mt-12">
            <AddToCart
              classNames="w-full md:w-80"
              product={{
                gift_card: giftCardValue,
                sku: giftCard.sku,
                quantity: 1,
                seller_id: 1,
                additional_data: {
                  gift_card: {
                    theme: "standard",
                    from_name: senderName,
                    message: senderMessage,
                    to_name: receiverName,
                    to_email: receiverEmail,
                    value: giftCardValue,
                  },
                },
              }}
              disabled={submitting || pristine || invalid}
            />
          </div>
        </form>
      )}
    />
  );
};

export default GiftCardForm;
